/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DashResponse } from '../models';
// @ts-ignore
import { DietQualityScoreResponse } from '../models';
// @ts-ignore
import { HeiComponentsResponse } from '../models';
// @ts-ignore
import { HeiMealResponse } from '../models';
// @ts-ignore
import { HeiResponse } from '../models';
// @ts-ignore
import { MediterraneanScoreHistoryResponse } from '../models';
// @ts-ignore
import { MediterraneanScoreResponse } from '../models';
// @ts-ignore
import { MindScoreResponse } from '../models';
// @ts-ignore
import { PatientMetricsResponse } from '../models';
/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Query the patient\'s HEI over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMetricsHEIGetHEI: async (patient_id: number, date_since: string, date_until: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEI', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEI', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEI', 'date_until', date_until)
            const localVarPath = `/metrics/patients/{patient_id}/HEI`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s HEI components over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMetricsHEIGetHEIComponents: async (patient_id: number, date_since: string, date_until: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEIComponents', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEIComponents', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEIComponents', 'date_until', date_until)
            const localVarPath = `/metrics/patients/{patient_id}/HEI/components`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s HEI for a specific meal
         * @param {number} patient_id 
         * @param {number} meal_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMetricsHEIGetHEIMeal: async (patient_id: number, meal_id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEIMeal', 'patient_id', patient_id)
            // verify required parameter 'meal_id' is not null or undefined
            assertParamExists('appApiMetricsHEIGetHEIMeal', 'meal_id', meal_id)
            const localVarPath = `/metrics/patients/{patient_id}/HEI/{meal_id}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"meal_id"}}`, encodeURIComponent(String(meal_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate the value for a specific metric for a defined period up to certain date
         * @param {string} metric_name 
         * @param {AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum} time_period 
         * @param {string} end_date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsReportMetricsGetMetrics: async (metric_name: string, time_period: AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum, end_date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metric_name' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsGetMetrics', 'metric_name', metric_name)
            // verify required parameter 'time_period' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsGetMetrics', 'time_period', time_period)
            // verify required parameter 'end_date' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsGetMetrics', 'end_date', end_date)
            const localVarPath = `/metrics/{metric_name}/{time_period}`
                .replace(`{${"metric_name"}}`, encodeURIComponent(String(metric_name)))
                .replace(`{${"time_period"}}`, encodeURIComponent(String(time_period)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (end_date !== undefined) {
                localVarQueryParameter['end_date'] = end_date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post fake metrics for testing purposes
         * @param {number} patient_id 
         * @param {string} time_period 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {PatientMetricsResponse} PatientMetricsResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsReportMetricsPostMetrics: async (patient_id: number, time_period: string, date_since: string, date_until: string, PatientMetricsResponse: PatientMetricsResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsPostMetrics', 'patient_id', patient_id)
            // verify required parameter 'time_period' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsPostMetrics', 'time_period', time_period)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsPostMetrics', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsPostMetrics', 'date_until', date_until)
            // verify required parameter 'PatientMetricsResponse' is not null or undefined
            assertParamExists('appApiPatientReportsReportMetricsPostMetrics', 'PatientMetricsResponse', PatientMetricsResponse)
            const localVarPath = `/metrics/testing/{patient_id}/{time_period}`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)))
                .replace(`{${"time_period"}}`, encodeURIComponent(String(time_period)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(PatientMetricsResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s DASH over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsDashGetDash: async (patient_id: number, date_since: string, date_until: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDashGetDash', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDashGetDash', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDashGetDash', 'date_until', date_until)
            const localVarPath = `/metrics/patients/{patient_id}/DASH`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s Diet Quality Score over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore: async (patient_id: number, date_since: string, date_until: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore', 'date_until', date_until)
            const localVarPath = `/metrics/patients/{patient_id}/diet_quality_score`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the Diet Quality Score for several clinics over a time period
         * @param {Array<number>} clinic_ids 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic: async (clinic_ids: Array<number>, date_since: string, date_until: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinic_ids' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic', 'clinic_ids', clinic_ids)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic', 'date_until', date_until)
            const localVarPath = `/metrics/diet_quality_score_by_clinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clinic_ids) {
                localVarQueryParameter['clinic_ids'] = clinic_ids;
            }

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s MIND score over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {boolean} disaggregated 
         * @param {boolean} [use_ranking_filter] 
         * @param {boolean} [use_insufficient_meal_filter] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsMindGetMediterraneanScore: async (patient_id: number, date_since: string, date_until: string, disaggregated: boolean, use_ranking_filter?: boolean, use_insufficient_meal_filter?: boolean, version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScore', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScore', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScore', 'date_until', date_until)
            // verify required parameter 'disaggregated' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScore', 'disaggregated', disaggregated)
            const localVarPath = `/metrics/patients/{patient_id}/mediterranean`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }

            if (disaggregated !== undefined) {
                localVarQueryParameter['disaggregated'] = disaggregated;
            }

            if (use_ranking_filter !== undefined) {
                localVarQueryParameter['use_ranking_filter'] = use_ranking_filter;
            }

            if (use_insufficient_meal_filter !== undefined) {
                localVarQueryParameter['use_insufficient_meal_filter'] = use_insufficient_meal_filter;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s Mediterranean score history over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {number} [window_days] 
         * @param {AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsMindGetMediterraneanScoreHistory: async (patient_id: number, date_since: string, date_until: string, window_days?: number, version?: AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScoreHistory', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScoreHistory', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMediterraneanScoreHistory', 'date_until', date_until)
            const localVarPath = `/metrics/patients/{patient_id}/mediterranean/history`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }

            if (window_days !== undefined) {
                localVarQueryParameter['window_days'] = window_days;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query the patient\'s MIND score over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {boolean} disaggregated 
         * @param {boolean} [use_ranking_filter] 
         * @param {boolean} [use_insufficient_meal_filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsMindGetMindScore: async (patient_id: number, date_since: string, date_until: string, disaggregated: boolean, use_ranking_filter?: boolean, use_insufficient_meal_filter?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patient_id' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMindScore', 'patient_id', patient_id)
            // verify required parameter 'date_since' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMindScore', 'date_since', date_since)
            // verify required parameter 'date_until' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMindScore', 'date_until', date_until)
            // verify required parameter 'disaggregated' is not null or undefined
            assertParamExists('appApiPatientReportsSectionsMindGetMindScore', 'disaggregated', disaggregated)
            const localVarPath = `/metrics/patients/{patient_id}/mind`
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patient_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date_since !== undefined) {
                localVarQueryParameter['date_since'] = date_since;
            }

            if (date_until !== undefined) {
                localVarQueryParameter['date_until'] = date_until;
            }

            if (disaggregated !== undefined) {
                localVarQueryParameter['disaggregated'] = disaggregated;
            }

            if (use_ranking_filter !== undefined) {
                localVarQueryParameter['use_ranking_filter'] = use_ranking_filter;
            }

            if (use_insufficient_meal_filter !== undefined) {
                localVarQueryParameter['use_insufficient_meal_filter'] = use_insufficient_meal_filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Query the patient\'s HEI over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMetricsHEIGetHEI(patient_id: number, date_since: string, date_until: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMetricsHEIGetHEI(patient_id, date_since, date_until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s HEI components over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMetricsHEIGetHEIComponents(patient_id: number, date_since: string, date_until: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeiComponentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMetricsHEIGetHEIComponents(patient_id, date_since, date_until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s HEI for a specific meal
         * @param {number} patient_id 
         * @param {number} meal_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiMetricsHEIGetHEIMeal(patient_id: number, meal_id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeiMealResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiMetricsHEIGetHEIMeal(patient_id, meal_id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Calculate the value for a specific metric for a defined period up to certain date
         * @param {string} metric_name 
         * @param {AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum} time_period 
         * @param {string} end_date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsReportMetricsGetMetrics(metric_name: string, time_period: AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum, end_date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsReportMetricsGetMetrics(metric_name, time_period, end_date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post fake metrics for testing purposes
         * @param {number} patient_id 
         * @param {string} time_period 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {PatientMetricsResponse} PatientMetricsResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsReportMetricsPostMetrics(patient_id: number, time_period: string, date_since: string, date_until: string, PatientMetricsResponse: PatientMetricsResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsReportMetricsPostMetrics(patient_id, time_period, date_since, date_until, PatientMetricsResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s DASH over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsSectionsDashGetDash(patient_id: number, date_since: string, date_until: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsSectionsDashGetDash(patient_id, date_since, date_until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s Diet Quality Score over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore(patient_id: number, date_since: string, date_until: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DietQualityScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore(patient_id, date_since, date_until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the Diet Quality Score for several clinics over a time period
         * @param {Array<number>} clinic_ids 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic(clinic_ids: Array<number>, date_since: string, date_until: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic(clinic_ids, date_since, date_until, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s MIND score over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {boolean} disaggregated 
         * @param {boolean} [use_ranking_filter] 
         * @param {boolean} [use_insufficient_meal_filter] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsSectionsMindGetMediterraneanScore(patient_id: number, date_since: string, date_until: string, disaggregated: boolean, use_ranking_filter?: boolean, use_insufficient_meal_filter?: boolean, version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediterraneanScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsSectionsMindGetMediterraneanScore(patient_id, date_since, date_until, disaggregated, use_ranking_filter, use_insufficient_meal_filter, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s Mediterranean score history over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {number} [window_days] 
         * @param {AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsSectionsMindGetMediterraneanScoreHistory(patient_id: number, date_since: string, date_until: string, window_days?: number, version?: AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediterraneanScoreHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsSectionsMindGetMediterraneanScoreHistory(patient_id, date_since, date_until, window_days, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Query the patient\'s MIND score over a time period
         * @param {number} patient_id 
         * @param {string} date_since 
         * @param {string} date_until 
         * @param {boolean} disaggregated 
         * @param {boolean} [use_ranking_filter] 
         * @param {boolean} [use_insufficient_meal_filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appApiPatientReportsSectionsMindGetMindScore(patient_id: number, date_since: string, date_until: string, disaggregated: boolean, use_ranking_filter?: boolean, use_insufficient_meal_filter?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MindScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appApiPatientReportsSectionsMindGetMindScore(patient_id, date_since, date_until, disaggregated, use_ranking_filter, use_insufficient_meal_filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @summary Query the patient\'s HEI over a time period
         * @param {MetricsApiAppApiMetricsHEIGetHEIRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMetricsHEIGetHEI(requestParameters: MetricsApiAppApiMetricsHEIGetHEIRequest, options?: AxiosRequestConfig): AxiosPromise<HeiResponse> {
            return localVarFp.appApiMetricsHEIGetHEI(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s HEI components over a time period
         * @param {MetricsApiAppApiMetricsHEIGetHEIComponentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMetricsHEIGetHEIComponents(requestParameters: MetricsApiAppApiMetricsHEIGetHEIComponentsRequest, options?: AxiosRequestConfig): AxiosPromise<HeiComponentsResponse> {
            return localVarFp.appApiMetricsHEIGetHEIComponents(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s HEI for a specific meal
         * @param {MetricsApiAppApiMetricsHEIGetHEIMealRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiMetricsHEIGetHEIMeal(requestParameters: MetricsApiAppApiMetricsHEIGetHEIMealRequest, options?: AxiosRequestConfig): AxiosPromise<HeiMealResponse> {
            return localVarFp.appApiMetricsHEIGetHEIMeal(requestParameters.patient_id, requestParameters.meal_id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate the value for a specific metric for a defined period up to certain date
         * @param {MetricsApiAppApiPatientReportsReportMetricsGetMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsReportMetricsGetMetrics(requestParameters: MetricsApiAppApiPatientReportsReportMetricsGetMetricsRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.appApiPatientReportsReportMetricsGetMetrics(requestParameters.metric_name, requestParameters.time_period, requestParameters.end_date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post fake metrics for testing purposes
         * @param {MetricsApiAppApiPatientReportsReportMetricsPostMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsReportMetricsPostMetrics(requestParameters: MetricsApiAppApiPatientReportsReportMetricsPostMetricsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appApiPatientReportsReportMetricsPostMetrics(requestParameters.patient_id, requestParameters.time_period, requestParameters.date_since, requestParameters.date_until, requestParameters.PatientMetricsResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s DASH over a time period
         * @param {MetricsApiAppApiPatientReportsSectionsDashGetDashRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsDashGetDash(requestParameters: MetricsApiAppApiPatientReportsSectionsDashGetDashRequest, options?: AxiosRequestConfig): AxiosPromise<DashResponse> {
            return localVarFp.appApiPatientReportsSectionsDashGetDash(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s Diet Quality Score over a time period
         * @param {MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore(requestParameters: MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreRequest, options?: AxiosRequestConfig): AxiosPromise<DietQualityScoreResponse> {
            return localVarFp.appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the Diet Quality Score for several clinics over a time period
         * @param {MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic(requestParameters: MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinicRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic(requestParameters.clinic_ids, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s MIND score over a time period
         * @param {MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsMindGetMediterraneanScore(requestParameters: MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreRequest, options?: AxiosRequestConfig): AxiosPromise<MediterraneanScoreResponse> {
            return localVarFp.appApiPatientReportsSectionsMindGetMediterraneanScore(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, requestParameters.disaggregated, requestParameters.use_ranking_filter, requestParameters.use_insufficient_meal_filter, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s Mediterranean score history over a time period
         * @param {MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsMindGetMediterraneanScoreHistory(requestParameters: MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryRequest, options?: AxiosRequestConfig): AxiosPromise<MediterraneanScoreHistoryResponse> {
            return localVarFp.appApiPatientReportsSectionsMindGetMediterraneanScoreHistory(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, requestParameters.window_days, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query the patient\'s MIND score over a time period
         * @param {MetricsApiAppApiPatientReportsSectionsMindGetMindScoreRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appApiPatientReportsSectionsMindGetMindScore(requestParameters: MetricsApiAppApiPatientReportsSectionsMindGetMindScoreRequest, options?: AxiosRequestConfig): AxiosPromise<MindScoreResponse> {
            return localVarFp.appApiPatientReportsSectionsMindGetMindScore(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, requestParameters.disaggregated, requestParameters.use_ranking_filter, requestParameters.use_insufficient_meal_filter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appApiMetricsHEIGetHEI operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiMetricsHEIGetHEIRequest
 */
export interface MetricsApiAppApiMetricsHEIGetHEIRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiMetricsHEIGetHEI
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiMetricsHEIGetHEI
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiMetricsHEIGetHEI
     */
    readonly date_until: string
}

/**
 * Request parameters for appApiMetricsHEIGetHEIComponents operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiMetricsHEIGetHEIComponentsRequest
 */
export interface MetricsApiAppApiMetricsHEIGetHEIComponentsRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiMetricsHEIGetHEIComponents
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiMetricsHEIGetHEIComponents
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiMetricsHEIGetHEIComponents
     */
    readonly date_until: string
}

/**
 * Request parameters for appApiMetricsHEIGetHEIMeal operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiMetricsHEIGetHEIMealRequest
 */
export interface MetricsApiAppApiMetricsHEIGetHEIMealRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiMetricsHEIGetHEIMeal
     */
    readonly patient_id: number

    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiMetricsHEIGetHEIMeal
     */
    readonly meal_id: number
}

/**
 * Request parameters for appApiPatientReportsReportMetricsGetMetrics operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsReportMetricsGetMetricsRequest
 */
export interface MetricsApiAppApiPatientReportsReportMetricsGetMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsGetMetrics
     */
    readonly metric_name: string

    /**
     * 
     * @type {'daily' | 'weekly'}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsGetMetrics
     */
    readonly time_period: AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsGetMetrics
     */
    readonly end_date: string
}

/**
 * Request parameters for appApiPatientReportsReportMetricsPostMetrics operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsReportMetricsPostMetricsRequest
 */
export interface MetricsApiAppApiPatientReportsReportMetricsPostMetricsRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsPostMetrics
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsPostMetrics
     */
    readonly time_period: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsPostMetrics
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsPostMetrics
     */
    readonly date_until: string

    /**
     * 
     * @type {PatientMetricsResponse}
     * @memberof MetricsApiAppApiPatientReportsReportMetricsPostMetrics
     */
    readonly PatientMetricsResponse: PatientMetricsResponse
}

/**
 * Request parameters for appApiPatientReportsSectionsDashGetDash operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsSectionsDashGetDashRequest
 */
export interface MetricsApiAppApiPatientReportsSectionsDashGetDashRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsSectionsDashGetDash
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsDashGetDash
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsDashGetDash
     */
    readonly date_until: string
}

/**
 * Request parameters for appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreRequest
 */
export interface MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScore
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScore
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScore
     */
    readonly date_until: string
}

/**
 * Request parameters for appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinicRequest
 */
export interface MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinicRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic
     */
    readonly clinic_ids: Array<number>

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic
     */
    readonly date_until: string
}

/**
 * Request parameters for appApiPatientReportsSectionsMindGetMediterraneanScore operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreRequest
 */
export interface MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly date_until: string

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly disaggregated: boolean

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly use_ranking_filter?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly use_insufficient_meal_filter?: boolean

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScore
     */
    readonly version?: string
}

/**
 * Request parameters for appApiPatientReportsSectionsMindGetMediterraneanScoreHistory operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryRequest
 */
export interface MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistory
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistory
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistory
     */
    readonly date_until: string

    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistory
     */
    readonly window_days?: number

    /**
     * 
     * @type {'1' | '2'}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistory
     */
    readonly version?: AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum
}

/**
 * Request parameters for appApiPatientReportsSectionsMindGetMindScore operation in MetricsApi.
 * @export
 * @interface MetricsApiAppApiPatientReportsSectionsMindGetMindScoreRequest
 */
export interface MetricsApiAppApiPatientReportsSectionsMindGetMindScoreRequest {
    /**
     * 
     * @type {number}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMindScore
     */
    readonly patient_id: number

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMindScore
     */
    readonly date_since: string

    /**
     * 
     * @type {string}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMindScore
     */
    readonly date_until: string

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMindScore
     */
    readonly disaggregated: boolean

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMindScore
     */
    readonly use_ranking_filter?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof MetricsApiAppApiPatientReportsSectionsMindGetMindScore
     */
    readonly use_insufficient_meal_filter?: boolean
}

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     * 
     * @summary Query the patient\'s HEI over a time period
     * @param {MetricsApiAppApiMetricsHEIGetHEIRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiMetricsHEIGetHEI(requestParameters: MetricsApiAppApiMetricsHEIGetHEIRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiMetricsHEIGetHEI(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s HEI components over a time period
     * @param {MetricsApiAppApiMetricsHEIGetHEIComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiMetricsHEIGetHEIComponents(requestParameters: MetricsApiAppApiMetricsHEIGetHEIComponentsRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiMetricsHEIGetHEIComponents(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s HEI for a specific meal
     * @param {MetricsApiAppApiMetricsHEIGetHEIMealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiMetricsHEIGetHEIMeal(requestParameters: MetricsApiAppApiMetricsHEIGetHEIMealRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiMetricsHEIGetHEIMeal(requestParameters.patient_id, requestParameters.meal_id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate the value for a specific metric for a defined period up to certain date
     * @param {MetricsApiAppApiPatientReportsReportMetricsGetMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsReportMetricsGetMetrics(requestParameters: MetricsApiAppApiPatientReportsReportMetricsGetMetricsRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsReportMetricsGetMetrics(requestParameters.metric_name, requestParameters.time_period, requestParameters.end_date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post fake metrics for testing purposes
     * @param {MetricsApiAppApiPatientReportsReportMetricsPostMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsReportMetricsPostMetrics(requestParameters: MetricsApiAppApiPatientReportsReportMetricsPostMetricsRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsReportMetricsPostMetrics(requestParameters.patient_id, requestParameters.time_period, requestParameters.date_since, requestParameters.date_until, requestParameters.PatientMetricsResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s DASH over a time period
     * @param {MetricsApiAppApiPatientReportsSectionsDashGetDashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsSectionsDashGetDash(requestParameters: MetricsApiAppApiPatientReportsSectionsDashGetDashRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsSectionsDashGetDash(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s Diet Quality Score over a time period
     * @param {MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore(requestParameters: MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsSectionsDietQualityScoreGetDietQualityScore(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the Diet Quality Score for several clinics over a time period
     * @param {MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic(requestParameters: MetricsApiAppApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinicRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsSectionsDietQualityScoreGetDietQualityScoreByClinic(requestParameters.clinic_ids, requestParameters.date_since, requestParameters.date_until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s MIND score over a time period
     * @param {MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsSectionsMindGetMediterraneanScore(requestParameters: MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsSectionsMindGetMediterraneanScore(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, requestParameters.disaggregated, requestParameters.use_ranking_filter, requestParameters.use_insufficient_meal_filter, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s Mediterranean score history over a time period
     * @param {MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsSectionsMindGetMediterraneanScoreHistory(requestParameters: MetricsApiAppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsSectionsMindGetMediterraneanScoreHistory(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, requestParameters.window_days, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query the patient\'s MIND score over a time period
     * @param {MetricsApiAppApiPatientReportsSectionsMindGetMindScoreRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public appApiPatientReportsSectionsMindGetMindScore(requestParameters: MetricsApiAppApiPatientReportsSectionsMindGetMindScoreRequest, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).appApiPatientReportsSectionsMindGetMindScore(requestParameters.patient_id, requestParameters.date_since, requestParameters.date_until, requestParameters.disaggregated, requestParameters.use_ranking_filter, requestParameters.use_insufficient_meal_filter, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum = {
    Daily: 'daily',
    Weekly: 'weekly'
} as const;
export type AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum = typeof AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum[keyof typeof AppApiPatientReportsReportMetricsGetMetricsTimePeriodEnum];
/**
 * @export
 */
export const AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum = {
    _1: '1',
    _2: '2'
} as const;
export type AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum = typeof AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum[keyof typeof AppApiPatientReportsSectionsMindGetMediterraneanScoreHistoryVersionEnum];
